import { put, call, select } from 'redux-saga/effects';
import applicationActions from 'redux/actions/applicationActions';
import { addGtmDataLayer } from 'redux/actions/gtmActions';
import { getConfigAndUrl } from 'api/config';
import { synergyStaticDataLayer } from 'constants/gtm';
import { getConfigData } from './gtm-saga-helper';
import { customStepsSelector } from 'redux/selectors/config';
import { caseOpeningRoutes, synergyRoutes } from 'Routes/routesConfig';
import { routeSelector } from 'redux/selectors/router';
const { setConfigurationSuccess, setConfigurationFail } = applicationActions;

export default function* setConfig() {
  try {
    const { config, provider } = yield call(getConfigAndUrl);
    yield put(setConfigurationSuccess({ ...config, provider }));
    const customSteps = (yield select(customStepsSelector)) || [];
    const currentRoute = yield select(routeSelector);
    const isCaseOpening = [
      ...caseOpeningRoutes,
      ...synergyRoutes,
      ...customSteps,
    ].filter(route => route.path === currentRoute).length;
    const dataLayer = {
      ...synergyStaticDataLayer,
      digital_business_process: isCaseOpening
        ? 'assistance_request'
        : 'follow_up',
    };

    yield put(
      addGtmDataLayer({
        ...dataLayer,
        ...getConfigData(config),
        business_line: 'motor_and_home_solutions',
      }),
    );
  } catch (error) {
    yield put(setConfigurationFail(error));
  }
}
